<template>
  <div class="get-card">
    <el-input class="input-class" v-model="getId" placeholder="请输入ID">
      <el-button slot="append" type="primary" @click="searchId">搜索</el-button>
    </el-input>
    <refresh-dialog v-if="showCard" :id='getId' :info='info'></refresh-dialog>
  </div>
</template>

<script>
import RefreshDialog from '../../components/Recommend/RefreshDialog'

export default {
  data () {
    return {
      showCard: false,
      getId: '',
      info: null
    }
  },
  components: {
    RefreshDialog
  },
  methods: {
    searchId () {
      this.showCard = false
      this.$axios.post('/recruitment/position/detail', {
        id: this.getId
      }).then(res => {
        this.info = res.data.employ
        this.showCard = true
      })
    }
  }
}
</script>

<style lang='scss'>
@import '$styles/global.scss';

.get-card{
  width: 100%;
  @include flex-box();
  padding: 50px;
  box-sizing: border-box;

  .input-class{
    width: 300px;
  }
}
</style>
